import { useMemo } from 'react';

import { PeerTypes } from '@givebacks/api/store';
import { useFormListValidation } from 'core/Hooks';
import { UseFormReturnType } from 'ui/Form';

interface PeerCreditForm {
  credits: { value: string; type: string; label: string }[];
  peerType: PeerTypes;
}
type UsePeerCreditForm = UseFormReturnType<PeerCreditForm>;
type Form = {
  credits?: UsePeerCreditForm;
};

const usePeerCreditsForm = () => {
  const { validateForms, useGetForm } = useFormListValidation<Form>();
  const creditForm = useGetForm('credits');

  const credits = useMemo(() => {
    const formValues = creditForm?.values.credits;
    const creditTo = formValues
      ?.filter((credit) => credit.type === 'credit_to')
      .map((credit) => credit.value);

    const creditWriteIn = formValues
      ?.filter((credit) => credit.type === 'credit_write_in')
      .map((credit) => credit.value);

    const creditLabel = formValues?.map((credit) => credit.label);

    return {
      credit_to: creditTo,
      credit_write_in: creditWriteIn,
      credit_label: creditLabel,
    };
  }, [creditForm?.values.credits]);

  const cartCredits = useMemo(
    () => ({
      ...credits,
      peerType: creditForm?.values.peerType,
    }),
    [creditForm?.values.peerType, credits]
  );

  return {
    cartCredits,
    validateForms,
    credit_to: cartCredits?.credit_to,
    credit_write_in: cartCredits?.credit_write_in,
  };
};

export { usePeerCreditsForm };
export type { PeerCreditForm, UsePeerCreditForm };
